import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SimulateSelectDialog from "./SimulateSelectDialog";
import CustomBackdrop from "../CustomBackdrop";
import { switchBackToSelf } from "../../datasource/impersonate";
import { getUserInfo } from "../../datasource/attr";

const store = require("store");

export default function SimulateSelectControl({
  variant = "desktop",
  onMobileMenuClose,
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reverting, setReverting] = useState(false);
  
  const [canSelect, setCanSelect] = useState(
    store.get("simulate_select") === true
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (!store.get("access_token")) return;
        const res = await getUserInfo();
        const rows = Array.isArray(res?.data) ? res.data : [];
        const flag = !!(rows[0]?.simulate_select);
        store.set("simulate_select", flag);
        if (!cancelled) setCanSelect(flag);
      } catch (err) {
        
        console.error("[SimulateSelect] refresh flag failed", err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const actingAs = store.get("impersonate_username");
  const displayEng = store.get("fullname_eng");
  const displayChi = store.get("fullname_chi");
  const displayName = displayEng || displayChi || actingAs;

  const handleRevert = async () => {
    if (reverting) return;
    setReverting(true);
    onMobileMenuClose?.();
    try {
      await switchBackToSelf();
      
      window.location.reload();
    } catch (err) {
      console.error(err);
      setReverting(false);
    }
  };

  const openDialog = () => {
    onMobileMenuClose?.();
    setDialogOpen(true);
  };

  const dialog = (
    <SimulateSelectDialog
      open={dialogOpen}
      onClose={() => setDialogOpen(false)}
    />
  );

  const loadingOverlay = reverting ? (
    <CustomBackdrop text="正在返回本人…" />
  ) : null;

  if (variant === "banner") {
    return null;
  }

  if (!canSelect && !actingAs) return null;

  if (variant === "mobile-menu") {
    return (
      <>
        {loadingOverlay}
        {canSelect && !actingAs ? (
          <MenuItem onClick={openDialog} sx={{ gap: 1 }} disabled={reverting}>
            <SwapHorizIcon fontSize="small" color="action" />
            模擬登錄…
          </MenuItem>
        ) : null}
        {actingAs ? (
          <MenuItem onClick={handleRevert} disabled={reverting} sx={{ gap: 1 }}>
            {reverting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <PersonOutlineIcon fontSize="small" color="action" />
            )}
            {reverting ? "返回中…" : "返回本人"}
          </MenuItem>
        ) : null}
        {dialog}
      </>
    );
  }

  return (
    <>
      {loadingOverlay}
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          ml: 1.25,
          flexShrink: 0,
        }}
      >
        {actingAs ? (
          <>
            <Tooltip
              title={`正在以 ${displayName}（${actingAs}）的身分操作`}
              arrow
            >
              <Chip
                size="small"
                label="模擬中"
                sx={{
                  height: 24,
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  bgcolor: "rgba(255, 236, 179, 0.95)",
                  color: "#5d4037",
                  border: "1px solid rgba(255, 224, 130, 0.9)",
                }}
              />
            </Tooltip>
            <Button
              size="small"
              color="inherit"
              disabled={reverting}
              startIcon={
                reverting ? (
                  <CircularProgress size={14} color="inherit" />
                ) : (
                  <PersonOutlineIcon sx={{ fontSize: 16 }} />
                )
              }
              onClick={handleRevert}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.75rem",
                letterSpacing: 0.2,
                px: 1,
                py: 0.25,
                minHeight: 28,
                borderRadius: 5,
                border: "1px solid rgba(255,255,255,0.45)",
                bgcolor: "rgba(0,0,0,0.12)",
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.22)",
                  borderColor: "rgba(255,255,255,0.65)",
                },
                "&.Mui-disabled": {
                  color: "rgba(255,255,255,0.85)",
                  borderColor: "rgba(255,255,255,0.35)",
                },
              }}
            >
              {reverting ? "返回中…" : "返回本人"}
            </Button>
          </>
        ) : canSelect ? (
          <Button
            color="inherit"
            size="small"
            startIcon={<SwapHorizIcon sx={{ fontSize: 18 }} />}
            onClick={openDialog}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              letterSpacing: 0.3,
              px: 1.25,
              py: 0.35,
              borderRadius: 5,
              border: "1px solid rgba(255,255,255,0.35)",
              bgcolor: "rgba(255,255,255,0.08)",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.18)",
                borderColor: "rgba(255,255,255,0.55)",
              },
            }}
          >
            模擬登錄
          </Button>
        ) : null}
      </Box>
      {dialog}
    </>
  );
}

export function simulateBannerOffset() {
  return 0;
}
